import React from "react";
import {useMediaQuery,useTheme,} from "@mui/material";
import { ContactDesktop } from "./ContactDesktop/ContactDesktop";
import { ContactMobile } from "./ContactMobile/ContactMobile";

const Contact = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
  <>
     {!isMobile && <ContactDesktop/>}
     {isMobile && <ContactMobile/>}
  </>
    
  );
};

export default Contact;